/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Add_FilesInputs */

const en_files_add_files = /** @type {(inputs: Files_Add_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add files`)
};

const es_files_add_files = /** @type {(inputs: Files_Add_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar archivos`)
};

/**
* | output |
* | --- |
* | "Add files" |
*
* @param {Files_Add_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_add_files = /** @type {((inputs?: Files_Add_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Add_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_add_files(inputs)
	return en_files_add_files(inputs)
});